import { Toast } from 'antd-mobile';
import { reportPage } from '@/utils/report';
import { PHASE_III_ACT_ID, REWARD_INFO } from './config';
import { jumpToPageByH5 } from '@/utils/fn';

export const showToast = () => {
  Toast.info('请升级到最新版本哦~');
};

export const handleJumpToRule = (type = 'old', page = 'invitor', actid = PHASE_III_ACT_ID) => {
  const nextUrl = `/agreement/invitev2/${type}user?origin=${page}&actid=${actid}`;
  jumpToPageByH5(nextUrl);
};

export const computerRewardLevel = inviteNum => {
  let level = 1;
  if (inviteNum > 5 && inviteNum < 31) {
    level = 2;
  } else if (inviteNum > 30 && inviteNum < 51) {
    level = 3;
  } else if (inviteNum >= 51) {
    level = 4;
  }
  const nextLevel = level === 4 ? 3 : level; // 下一等级在REWRD_INFO中的下标
  const nextLevelPeople = REWARD_INFO[nextLevel].peopleNum - inviteNum;
  const gapNum = nextLevelPeople > 0 ? nextLevelPeople : 0;
  return { gapNum, level, nextLevel };
};

export const reportPageFn = (data = { page_name: 'invite_v2' }) => {
  reportPage({
    module: 'invite',
    ...data,
  });
};

export const renderNum = num => {
  let dom = '--';
  if (num !== undefined) dom = num;
  return dom;
};
